import React, { useState } from 'react';
import {
  Form,
  Input,
  Col,
  Row,
  Modal,
  Button,
  Spin,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import Table from 'components/Table';
import API from 'utils/api';
import { onError } from 'utils/handlers';
import PropTypes from 'prop-types';

const CustomSearch = ({
  searchInputLabel,
  searchInputName,
  firstInputLabel,
  firstInputName,
  secondInputLabel,
  secondInputName,
  thirdInputLabel,
  thirdInputName,
  firstSelectLabel,
  firstSelectName,
  firstSelectDataSource,
  secondSelectLabel,
  secondSelectName,
  secondSelectDataSource,
  modalTitle,
  modalWidth,
  inputsNeeded,
  selectsNeeded,
  paginatedTable,
  setSelectedRow,
  open,
  setVisible,
  columns,
  baseURI,
  baseURIExtra,
  onFinishGet,
  data,
  setData,
  searchData,
  onChange,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formSearch] = Form.useForm();

  const search = async () => {
    setLoading(true);
    const firstInputVal = formSearch.getFieldValue(firstInputName);
    const secondInputVal = formSearch.getFieldValue(secondInputName);
    const thirdInputVal = formSearch.getFieldValue(thirdInputName);
    const searchInputVal = formSearch.getFieldValue(searchInputName);
    const firstSelectVal = formSearch.getFieldValue(firstSelectName);
    const secondSelectVal = formSearch.getFieldValue(secondSelectName);
    /* eslint-disable-next-line max-len */
    searchData(
      firstInputVal,
      secondInputVal,
      searchInputVal,
      thirdInputVal,
      firstSelectVal,
      secondSelectVal,
    );
    setLoading(false);
  };

  const fetchPaginated = async (page = 1) => {
    try {
      setLoading(true);
      const response = await API.get(`${baseURI}&page=${page}&`);
      const responseResults = response.data.results;
      setData({ ...response.data, responseResults });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onCancel = () => {
    formSearch.resetFields();
    setSelectedRowKeys();
    setData();
    setVisible(false);
  };

  const onFinish = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const match = await onFinishGet(`${baseURI}&id=${selectedRowKeys}&`);
      const results = match?.results[0];
      if (paginatedTable) {
        const empResult = results?.empleado;
        if (onChange) {
          await onChange(empResult?.id);
        }
        setSelectedRow(empResult);
        onCancel();
        return setLoading(false);
      }
      setSelectedRow(results);
      if (onChange) {
        await onChange(results);
      }
      onCancel();
      return setLoading(false);
    }
    onCancel();
    return setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width={modalWidth}
          title={(
            <FormSubmitControls
              label={modalTitle}
              onFinish={onFinish}
              disableOnFinish={!selectedRowKeys?.length}
              onFinishText="Seleccionar"
              onCancel={onCancel}
              selectedRowKeys={selectedRowKeys}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={formSearch}
            scrollToFirstError
            name="search"
          >
            <Row gutter={10}>
              {inputsNeeded >= 1
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={firstInputLabel}
                      name={firstInputName}
                      hasFeedback
                    >
                      <Input
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              {inputsNeeded >= 2
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={secondInputLabel}
                      name={secondInputName}
                      hasFeedback
                    >
                      <Input
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={15}>
                    <Form.Item
                      label={searchInputLabel}
                      name={searchInputName}
                      hasFeedback
                    >
                      <Input
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button
                      onClick={search}
                      icon={<SearchOutlined />}
                      style={{
                        backgroundColor: 'rgb(40, 80, 95)',
                        color: 'white',
                        width: '110px',
                        height: '34px',
                        marginBottom: '0.3vh',
                      }}
                    >
                      Buscar
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={10}>
              {inputsNeeded >= 3
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={thirdInputLabel}
                      name={thirdInputName}
                      hasFeedback
                    >
                      <Input
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              {selectsNeeded >= 1
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={firstSelectLabel}
                      name={firstSelectName}
                      hasFeedback
                    >
                      <Select
                        allowClear
                        dataSource={firstSelectDataSource}
                      />
                    </Form.Item>
                  </Col>
                ) : null }
              {selectsNeeded >= 2
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label={secondSelectLabel}
                      name={secondSelectName}
                      hasFeedback
                    >
                      <Select
                        allowClear
                        dataSource={secondSelectDataSource}
                      />
                    </Form.Item>
                  </Col>
                ) : null }
            </Row>
          </Form>
          {paginatedTable
            ? (
              <Table
                allowColumnSelector={false}
                cols={columns}
                data={data?.results}
                baseURI={baseURI}
                baseURIExtra={baseURIExtra}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                pagination={false}
                paginationCallback={fetchPaginated}
                count={data?.count}
                loading={loading}
                allowExportParam={false}
                allowImportParam={false}
                allowSearch={false}
                // permission={permission}
              />
            ) : null}
          {!paginatedTable
            ? (
              <Table
                allowColumnSelector={false}
                cols={columns}
                data={data}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                loading={loading}
                allowExportParam={false}
                allowImportParam={false}
              />
            ) : null}
        </Modal>
      </Spin>
    </Row>
  );
};

CustomSearch.propTypes = {
  searchInputLabel: PropTypes.string,
  searchInputName: PropTypes.string,
  firstInputLabel: PropTypes.string,
  firstInputName: PropTypes.string,
  secondInputLabel: PropTypes.string,
  secondInputName: PropTypes.string,
  thirdInputLabel: PropTypes.string,
  thirdInputName: PropTypes.string,
  firstSelectLabel: PropTypes.string,
  firstSelectName: PropTypes.string,
  firstSelectDataSource: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  secondSelectLabel: PropTypes.string,
  secondSelectName: PropTypes.string,
  secondSelectDataSource: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  modalTitle: PropTypes.string,
  modalWidth: PropTypes.number,
  inputsNeeded: PropTypes.number,
  selectsNeeded: PropTypes.number,
  paginatedTable: PropTypes.bool,
  setSelectedRow: PropTypes.func.isRequired,
  open: PropTypes.bool,
  setVisible: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  baseURI: PropTypes.string,
  baseURIExtra: PropTypes.string,
  onFinishGet: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  setData: PropTypes.func,
  searchData: PropTypes.func,
  onChange: PropTypes.func,
};

CustomSearch.defaultProps = {
  searchInputLabel: 'Search Input Name',
  searchInputName: 'apellido_paterno',
  firstInputLabel: 'First Input',
  firstInputName: 'first_input',
  secondInputLabel: 'Second Input',
  secondInputName: 'second_input',
  thirdInputLabel: 'Third Input',
  thirdInputName: 'third_input',
  firstSelectLabel: 'First Select',
  firstSelectName: 'first_select',
  firstSelectDataSource: [],
  secondSelectLabel: 'Second Select',
  secondSelectName: 'second_select',
  secondSelectDataSource: [],
  modalTitle: 'Buscar Empleado',
  modalWidth: 1000,
  inputsNeeded: 3,
  selectsNeeded: 2,
  paginatedTable: false,
  open: false,
  setVisible: null,
  columns: [],
  baseURI: '',
  baseURIExtra: '',
  onFinishGet: null,
  data: [],
  setData: [],
  searchData: null,
  onChange: null,
};

export default CustomSearch;
